import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/zusaetzliche-merkmale/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="AdditionalFeatures"
      returnRoute="/auswahlfelder/additionalFeatures"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const AdditionalFeaturesRoute = Route;
